
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!calendar.agenda_view";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'calendar/agendaView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.days), {hash:{},inverse:self.noop,fn:self.programWithDepth(2, program2, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program2(depth0,data,depth1) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <div class=\"agenda-day";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isToday), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n        <h3 class=\"agenda-date\" tabindex=\"-1\">\n          <span aria-hidden=\"true\">";
  if (helper = helpers.date) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.date); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n          <span class=\"screenreader-only\">";
  if (helper = helpers.accessibleDate) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.accessibleDate); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n        </h3>\n      </div>\n\n        <div class=\"agenda-event__container\">\n          <ul class=\"agenda-event__list\">\n            ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.events), {hash:{},inverse:self.noop,fn:self.programWithDepth(5, program5, data, depth1),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </ul>\n        </div>\n\n    ";
  return buffer;
  }
function program3(depth0,data) {
  
  
  return " agenda-today";
  }

function program5(depth0,data,depth2) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <li class=\"agenda-event__item\" data-event-id=\"";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n                <span class=\"screenreader-only\">\n                  ";
  if (helper = helpers.readableType) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.readableType); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + ",\n                  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment), {hash:{},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ",\n                </span>\n                <span class=\"screenreader-only\">\n                  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth2 && depth2.meta)),stack1 == null || stack1 === false ? stack1 : stack1.use_scheduler), {hash:{},inverse:self.programWithDepth(24, program24, data, depth2),fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                </span>\n                <span class=\"screenreader-only\">\n                  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isCompleted), {hash:{},inverse:self.program(29, program29, data),fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                </span>\n                <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'contextInfo.name': (((stack1 = (depth0 && depth0.contextInfo)),stack1 == null || stack1 === false ? stack1 : stack1.name)),
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "calendar_contextinfo_name_a7d98525", "Calendar %{contextInfo.name}", options) : helperMissing.call(depth0, "t", "calendar_contextinfo_name_a7d98525", "Calendar %{contextInfo.name}", options)))
    + "</span>\n                <div class=\"agenda-event__item-container\" tabindex=\"0\" role=\"button\">\n                  <div class=\"agenda-event__icon group_";
  if (helper = helpers.contextCode) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.contextCode); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n                    <i class=\"icon-";
  if (helper = helpers.iconType) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.iconType); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></i>\n                  </div>\n                  <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "open_event_menu_for_783510e3", "Open event menu for", options) : helperMissing.call(depth0, "t", "open_event_menu_for_783510e3", "Open event menu for", options)))
    + " ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n                  <div class=\"agenda-event__time\" aria-hidden=\"true\">\n                    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assignment), {hash:{},inverse:self.program(33, program33, data),fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  </div>\n                  <span class=\"agenda-event__title group_";
  if (helper = helpers.contextCode) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.contextCode); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isCompleted), {hash:{},inverse:self.noop,fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n                    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth2 && depth2.meta)),stack1 == null || stack1 === false ? stack1 : stack1.use_scheduler), {hash:{},inverse:self.programWithDepth(46, program46, data, depth2),fn:self.program(38, program38, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  </span>\n                </div>\n              </li>\n            ";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "due_a73610f6", "Due", options) : helperMissing.call(depth0, "t", "due_a73610f6", "Due", options)))
    + " "
    + escapeExpression((helper = helpers.fcMomentToString || (depth0 && depth0.fcMomentToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.originalStart), "tiny", options) : helperMissing.call(depth0, "fcMomentToString", (depth0 && depth0.originalStart), "tiny", options)))
    + "\n                  ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.allDay), {hash:{},inverse:self.program(11, program11, data),fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  ";
  return buffer;
  }
function program9(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "all_day_fb42c4fc", "All Day", options) : helperMissing.call(depth0, "t", "all_day_fb42c4fc", "All Day", options)))
    + "\n                      "
    + escapeExpression((helper = helpers.fcMomentToDateString || (depth0 && depth0.fcMomentToDateString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.originalStart), "short", options) : helperMissing.call(depth0, "fcMomentToDateString", (depth0 && depth0.originalStart), "short", options)))
    + "\n                    ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "starts_at_29843f98", "Starts at", options) : helperMissing.call(depth0, "t", "starts_at_29843f98", "Starts at", options)))
    + "\n                      "
    + escapeExpression((helper = helpers.fcMomentToString || (depth0 && depth0.fcMomentToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.originalStart), "tiny", options) : helperMissing.call(depth0, "fcMomentToString", (depth0 && depth0.originalStart), "tiny", options)))
    + "\n                      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "ends_at_9a62b528", "Ends at", options) : helperMissing.call(depth0, "t", "ends_at_9a62b528", "Ends at", options)))
    + "\n                      "
    + escapeExpression((helper = helpers.fcMomentToString || (depth0 && depth0.fcMomentToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end), "tiny", options) : helperMissing.call(depth0, "fcMomentToString", (depth0 && depth0.end), "tiny", options)))
    + "\n                    ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isAppointmentGroupEvent), {hash:{},inverse:self.program(22, program22, data),fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  ";
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_edit), {hash:{},inverse:self.program(20, program20, data),fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                    ";
  return buffer;
  }
function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                        ";
  stack1 = (helper = helpers.truncate || (depth0 && depth0.truncate),options={hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.title), 60, options) : helperMissing.call(depth0, "truncate", (depth0 && depth0.title), 60, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " - ";
  if (helper = helpers.appointmentGroupEventStatus) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.appointmentGroupEventStatus); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reservedUsers), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                      ";
  return buffer;
  }
function program16(depth0,data) {
  
  var buffer = "";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += " - ";
  if (helper = helpers.reservedUsers) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.reservedUsers); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  return buffer;
  }

function program20(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                        ";
  stack1 = (helper = helpers.truncate || (depth0 && depth0.truncate),options={hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.title), 60, options) : helperMissing.call(depth0, "truncate", (depth0 && depth0.title), 60, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " - ";
  if (helper = helpers.appointmentGroupEventStatus) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.appointmentGroupEventStatus); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                      ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                      ";
  stack1 = (helper = helpers.truncate || (depth0 && depth0.truncate),options={hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.title), 60, options) : helperMissing.call(depth0, "truncate", (depth0 && depth0.title), 60, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                    ";
  return buffer;
  }

function program24(depth0,data,depth3) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    ";
  stack1 = (helper = helpers.ifAll || (depth3 && depth3.ifAll),options={hash:{},inverse:self.program(22, program22, data),fn:self.program(25, program25, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth3 && depth3.meta)),stack1 == null || stack1 === false ? stack1 : stack1.displayAppointmentEvents), (depth0 && depth0.isAppointmentGroupEvent), options) : helperMissing.call(depth0, "ifAll", ((stack1 = (depth3 && depth3.meta)),stack1 == null || stack1 === false ? stack1 : stack1.displayAppointmentEvents), (depth0 && depth0.isAppointmentGroupEvent), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  ";
  return buffer;
  }
function program25(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                      ";
  if (helper = helpers.appointmentGroupEventStatus) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.appointmentGroupEventStatus); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                    ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "completed_9b809e44", "completed", options) : helperMissing.call(depth0, "t", "completed_9b809e44", "completed", options)))
    + "\n                  ";
  return buffer;
  }

function program29(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "not_completed_55fb4c00", "Not Completed", options) : helperMissing.call(depth0, "t", "not_completed_55fb4c00", "Not Completed", options)))
    + "\n                  ";
  return buffer;
  }

function program31(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.agenda_view")
  },data:data},helper ? helper.call(depth0, "due", "Due", options) : helperMissing.call(depth0, "t", "due", "Due", options)))
    + " "
    + escapeExpression((helper = helpers.fcMomentToString || (depth0 && depth0.fcMomentToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.originalStart), "tiny", options) : helperMissing.call(depth0, "fcMomentToString", (depth0 && depth0.originalStart), "tiny", options)))
    + "\n                    ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.allDay), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                    ";
  return buffer;
  }
function program34(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                        "
    + escapeExpression((helper = helpers.fcMomentToString || (depth0 && depth0.fcMomentToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.originalStart), "tiny", options) : helperMissing.call(depth0, "fcMomentToString", (depth0 && depth0.originalStart), "tiny", options)))
    + "\n                      ";
  return buffer;
  }

function program36(depth0,data) {
  
  
  return "calendar__event--completed";
  }

function program38(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isAppointmentGroupEvent), {hash:{},inverse:self.program(44, program44, data),fn:self.program(39, program39, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                    ";
  return buffer;
  }
function program39(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_edit), {hash:{},inverse:self.program(42, program42, data),fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                      ";
  return buffer;
  }
function program40(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                          ";
  stack1 = (helper = helpers.truncate || (depth0 && depth0.truncate),options={hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.title), 60, options) : helperMissing.call(depth0, "truncate", (depth0 && depth0.title), 60, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " - ";
  if (helper = helpers.appointmentGroupEventStatus) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.appointmentGroupEventStatus); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reservedUsers), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                        ";
  return buffer;
  }

function program42(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                          ";
  stack1 = (helper = helpers.truncate || (depth0 && depth0.truncate),options={hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.title), 60, options) : helperMissing.call(depth0, "truncate", (depth0 && depth0.title), 60, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " - ";
  if (helper = helpers.appointmentGroupEventStatus) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.appointmentGroupEventStatus); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                        ";
  return buffer;
  }

function program44(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                        ";
  stack1 = (helper = helpers.truncate || (depth0 && depth0.truncate),options={hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.title), 60, options) : helperMissing.call(depth0, "truncate", (depth0 && depth0.title), 60, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                      ";
  return buffer;
  }

function program46(depth0,data,depth3) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                      ";
  stack1 = (helper = helpers.ifAll || (depth3 && depth3.ifAll),options={hash:{},inverse:self.program(44, program44, data),fn:self.program(47, program47, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth3 && depth3.meta)),stack1 == null || stack1 === false ? stack1 : stack1.displayAppointmentEvents), (depth0 && depth0.isAppointmentGroupEvent), options) : helperMissing.call(depth0, "ifAll", ((stack1 = (depth3 && depth3.meta)),stack1 == null || stack1 === false ? stack1 : stack1.displayAppointmentEvents), (depth0 && depth0.isAppointmentGroupEvent), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                    ";
  return buffer;
  }
function program47(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                        ";
  if (helper = helpers.appointmentGroupEventStatus) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.appointmentGroupEventStatus); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n                      ";
  return buffer;
  }

function program49(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<span class=\"agendaView--no-assignments\">$1</span>"),
    'scope': ("calendar.agenda_view")
  },data:data},helper ? helper.call(depth0, "no_events", "*No events after this date.*", options) : helperMissing.call(depth0, "t", "no_events", "*No events after this date.*", options)))
    + "\n  ";
  return buffer;
  }

function program51(depth0,data) {
  
  
  return "\n    <a href=\"#\" class=\"btn agenda-load-btn\" role=\"button\">Load more</a>\n  ";
  }

  buffer += "<div class=\"agenda-container\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.days), {hash:{},inverse:self.program(49, program49, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<div class=\"agenda-actions\">\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.meta)),stack1 == null || stack1 === false ? stack1 : stack1.hasMore), {hash:{},inverse:self.noop,fn:self.program(51, program51, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <i class=\"loading-spinner\"\n    aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("calendar.agenda_view")
  },data:data},helper ? helper.call(depth0, "loading", "Loading", options) : helperMissing.call(depth0, "t", "loading", "Loading", options)))
    + "\"\n    aria-hidden=\"true\"></i>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  